module.exports = __webpack_public_path__ + "static/media/creativesHead2.c065a29f.jpg";